module.exports = __webpack_public_path__ + "media/images/front/icons/green_cumulus-62a660c20235acd1244592702310ff72.svg";